import { put, call, all, takeLatest } from 'redux-saga/effects';
import { merge, get, clone, set } from 'lodash';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { APIUSER, APICOMMON, APICOPYRIGHT } from '../../../actionApi';
import { request } from '../../../utils/request';
import { API } from '../../../env';
function* getTopicList(data) {
	let { payload, callback, errorCallback } = data;
	console.log('payload', payload);
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.COPYRIGHTTOPICLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		// console.log ("pageSize....",payload.pageSize)
		if (payload.limit === 1) {
			yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_TOPICLIST, payload: result });
		} else {
			yield put({ type: ACITONCOPYRIGHT.SET_ACTIVITYLIST_LIST, payload: result });
		}
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getSportList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.COPYRIGHTSPORTLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_SPORTLIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getPlacardItemList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.PLACARDITEMLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...。。。。。', result);
		yield put({ type: ACITONCOPYRIGHT.SET_PLACARDITEM_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* setNewsPraise(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.INSERTNEWSPRAISE,
		dataParam: payload || {}
		// contentType: 'multipart/form-data'
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		let { index } = payload;
		yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_NEWSPRAISE_HOME, payload: {index} });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* setCancelNewsPraise(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.DELETENEWSPRAISE,
		dataParam: payload || {}
		// contentType: 'multipart/form-data'
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		let { index } = payload;
		yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_CANCELNEWSPRAISE_HOME, payload: {index} });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}

let homeSaga = [
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_TOPICLIST, getTopicList),
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_SPORTLIST, getSportList),
	takeLatest(ACITONCOPYRIGHT.FETCH_PLACARDITEM_LIST, getPlacardItemList),
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_NEWSPRAISE_HOME, setNewsPraise),
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_CANCELNEWSPRAISE_HOME, setCancelNewsPraise)
];
export { homeSaga };
